module.exports = __webpack_public_path__ + "img/outlook_sync_error.7ad80ba0.png";